import { Component, Input, Output, EventEmitter, HostListener, TemplateRef, OnInit, OnDestroy } from '@angular/core';

@Component({
	selector: 'bb-dialog',
	templateUrl: './bb-dialog.component.html',
	styleUrls: ['./bb-dialog.component.scss']
})

export class BbDialogComponent implements OnInit, OnDestroy {
	@Input() title: string;
	@Input() contents: string;
	@Input() icon: string;
	@Input() templateRef: TemplateRef<any>;
	@Input() showSave = false;
	@Output() onCancel = new EventEmitter();
	@Output() onConfirm = new EventEmitter();
	@Output() onSaveAndClose = new EventEmitter();

	confirmed = false;

	constructor() { }

	@HostListener('document:keydown', ['$event'])
	onKeyUp(ev: KeyboardEvent) {
		if (ev.key === 'Escape') {

			if (this.confirmed) {
				return; // ignore
			}

			this.cancel();
		}

		if (ev.key === 'Enter') {

			if (this.confirmed) {
				return; // ignore
			}

			this.confirm();
		}
	}

	ngOnInit() { }

	ngOnDestroy() { }

	cancel() {
		this.onCancel.emit();
	}

	confirm() {
		this.confirmed = true;
		this.onConfirm.emit();
	}

	saveAndClose() {
		this.onSaveAndClose.emit();
	}
}
